import { render, staticRenderFns } from "./PopupOrderFail.vue?vue&type=template&id=63ebee3f&scoped=true&"
import script from "./PopupOrderFail.vue?vue&type=script&lang=js&"
export * from "./PopupOrderFail.vue?vue&type=script&lang=js&"
import style0 from "./PopupOrderFail.vue?vue&type=style&index=0&id=63ebee3f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ebee3f",
  null
  
)

export default component.exports